<template>
  <v-dialog
    persistent
    :value="true"
    max-width="500"
  >
    <v-card>
      <v-card-text class="pa-5">
        <v-list-item class="px-0">
          <v-list-item-avatar class="mr-3 align-self-start">
            <v-icon
              :color="color"
              size="30"
              v-text="icon"
            />
          </v-list-item-avatar>

          <div>
            <div
              :class="color + '--text'"
              class="subtitle-1 font-weight-bold mb-1"
              v-text="title"
            />
            <div
              class="subtitle body-2 grey--text"
              v-text="subtitle"
            />
          </div>
        </v-list-item>
      </v-card-text>

      <slot />

      <v-card-actions class="pa-5">
        <v-spacer />

        <v-btn
          color="grey"
          text
          @click="$emit('close')"
        >
          {{ closeText }}
        </v-btn>

        <v-btn
          depressed
          :color="color"
          :loading="isAcceptButtonLoading"
          :disabled="isAcceptButtonDisabled"
          @click="$emit('accept')"
        >
          {{ acceptText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'error',
    },
    icon: {
      type: String,
      default: 'mdi-alert-outline',
    },
    title: {
      type: String,
      default: 'Please Confirm',
    },
    subtitle: {
      type: String,
      default: 'Are you sure you want to perform this action?',
    },
    acceptText: {
      type: String,
      default: 'Accept',
    },
    closeText: {
      type: String,
      default: 'Close',
    },
    isAcceptButtonDisabled: {
      type: Boolean,
      default: false,
    },
    isAcceptButtonLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.subtitle {
  line-height: 20px;
}
</style>
